// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"Snackbar__snackbar___FhVCV","open":"Snackbar__open___25weV","showClose":"Snackbar__showClose___eDRjZ","snackbar--error":"Snackbar__snackbar--error___28Pch","snackbar--notice":"Snackbar__snackbar--notice___2WUPn","close":"Snackbar__close___3_EBC","close--active":"Snackbar__close--active___1X7vz","message":"Snackbar__message___1qwgg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Snackbar/Snackbar.scss
// module id = 1256
// module chunks = 1